import React from 'react';
import { Grid, Box, Typography, Divider, Skeleton } from '@mui/material';
import { DownArrow, GreenUpArrowIcon } from '../../../../assets';
import { useSelector } from 'react-redux';
import { getDifferenceBetweenDateRange } from '../../../../utility';

const TotalEngagementInfo = () => {
    const {
        engagementTotal, periodChange, isPeriodChangeIncrease, isLoading 
    } = useSelector((state) => state.totalEngagement);

    const { startDateRange, endDateRange } = useSelector((state) => state.filter);

    return (
        <>
            <Grid container>
                <Grid item xs={6}>
                    <Box className="flex-column gap-8">
                        <Box>
                            <Typography className="engagement-title">Total Physician Engagement</Typography>
                        </Box>
                        <Box className="flex-row">
                            <Box>
                                {isLoading? <Skeleton height={30} variant='text' width={60} /> : <Typography className="engagement-value">{engagementTotal}</Typography>}
                            </Box>
                            <Box className="flex-column gap-2 center-align ml-5-percent">
                                <Typography className={`text-sm-medium ${isPeriodChangeIncrease ? 'success-700' : 'error-700'}`}>
                                    {isLoading ? (
                                        <Skeleton variant='text' width={100} />
                                    ) : (
                                        <>
                                            {isPeriodChangeIncrease ? <GreenUpArrowIcon /> : <DownArrow />}
                                            {periodChange}
                                        </>
                                    )}
                                </Typography>
                                <Typography className="physicians-engagement-last-year">
                    vs Last {getDifferenceBetweenDateRange(startDateRange, endDateRange)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Divider className="mv-24 border-1-gray" />
        </>
    );
};

export default TotalEngagementInfo;
